import {
    ApplicationRef,
    ComponentFactoryResolver,
    ComponentRef,
    EmbeddedViewRef,
    Injectable,
    Injector,
} from '@angular/core';
import { Subject } from 'rxjs';

import { ModalRef } from '../../abstracts/modal-ref';
import { IComponentConfig } from '../../interfaces/component-config.interface';

@Injectable({
    providedIn: 'root',
})
export class DomService {
    private modalRef: ModalRef<any>;

    constructor(private appRef: ApplicationRef, public componentFactoryResolver: ComponentFactoryResolver, private injector: Injector) {}

    public appendComponentTo<ComponentType>(parentId: string, component: any, componentConfig?: IComponentConfig): ModalRef<ComponentType> {
        // Create a component reference from the component
        const componentRef = this.componentFactoryResolver.resolveComponentFactory(component).create(this.injector);

        if (componentConfig) {
            // Attach the config to the child (inputs and outputs)
            this.attachConfig(componentConfig, componentRef);
        }

        this.modalRef = new ModalRef({
            modalComponentRef: componentRef,
            onClose: new Subject(),
        });
        // Attach component to the appRef so that it's inside the ng component tree
        this.appRef.attachView(this.modalRef.modalComponentRef.hostView);

        // Get DOM element from component
        const childDomElem = (this.modalRef.modalComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

        // Append DOM element to the body
        document.getElementById(parentId).appendChild(childDomElem);
        return this.modalRef;
    }

    public removeComponent(): void {
        this.appRef.detachView(this.modalRef.modalComponentRef.hostView);
        this.modalRef.onClose.next();
        this.modalRef.onClose.complete();
        this.modalRef.modalComponentRef.destroy();
    }

    public getCurrentModal(): ModalRef<any> {
        return this.modalRef;
    }

    private attachConfig(config: IComponentConfig, componentRef: ComponentRef<any>): void {
        const inputs: any = config.inputs;
        const outputs: any = config.outputs;
        // eslint-disable-next-line
        for (const key in inputs) {
            componentRef.instance[key] = inputs[key];
        }
        // eslint-disable-next-line
        for (const key in outputs) {
            componentRef.instance[key] = outputs[key];
        }
    }
}
